import LookUpModel from "./LookUpModel";

export default class RequestedTypeModel extends LookUpModel {
    constructor(data: Partial<RequestedTypeModel>) {
        super(data);

        this.update(data);
    }
}
